import React, { useState, useCallback } from 'react';
import {
  SearchBarContainer,
  SearchBarLabel,
  SearchBarSelect,
  SearchBarInput,
  FilterButton,
} from './styles';

interface SearchBarProps {
  isActive: boolean;
  onFilterChange: (filters: any) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ isActive, onFilterChange }) => {
  const [localFilters, setLocalFilters] = useState({
    isActive: isActive,
    name: '',
    roles: '',
    email: '',
  });

  const handleFilterChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setLocalFilters((prevFilters) => ({
        ...prevFilters,
        isActive: e.target.value === 'true',
      }));
    },
    [],
  );

  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalFilters((prevFilters) => ({
        ...prevFilters,
        name: e.target.value,
      }));
    },
    [],
  );

  const handleRolesChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalFilters((prevFilters) => ({
        ...prevFilters,
        roles: e.target.value,
      }));
    },
    [],
  );

  const handleEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalFilters((prevFilters) => ({
        ...prevFilters,
        email: e.target.value,
      }));
    },
    [],
  );

  const handleFilterClick = useCallback(() => {
    onFilterChange(localFilters);
  }, [localFilters, onFilterChange]);

  return (
    <SearchBarContainer>
      <SearchBarLabel>
        <SearchBarSelect
          value={localFilters.isActive.toString()}
          onChange={handleFilterChange}
        >
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </SearchBarSelect>
      </SearchBarLabel>
      <SearchBarLabel>
        Username:
        <SearchBarInput type="text" onChange={handleNameChange} />
      </SearchBarLabel>
      <SearchBarLabel>
        Role:
        <SearchBarInput type="text" onChange={handleRolesChange} />
      </SearchBarLabel>
      <SearchBarLabel>
        Email:
        <SearchBarInput type="text" onChange={handleEmailChange} />
      </SearchBarLabel>
      <FilterButton onClick={handleFilterClick}>Filter</FilterButton>
    </SearchBarContainer>
  );
};

export default SearchBar;
